export enum ProcessState {
  Busy,
  Complete,
  Warning,
  Error
}
